export const MACRO_AREAS = [
  'All',
  'SAP Tr-Finance (FICO) SAP Retail (FMS1) NA',
  'SAP Tr-Logistics (SCM) SAP Retail (FMS1) NA',
  'SAP Tr-HR',
  'SAP Tr-Basis',
];

export const CONSULTANTS = ['All', 'Battula Hima Sri', 'NETKE AKSHAY', 'BADIN NICOLA'];

export const PERIODS = [
  '2020 11', '2021 01', '2021 06', '2022 01', '2022 06',
  '2023 01', '2023 06', '2024 01', '2024 06', '2025 01',
  '2025 06', '2026 02', '2026 04',
];

export const SHORTLIST_STATS = {
  ticketCount: 97,
  totalEffortHours: 2066.9,
};

export const HIERARCHICAL_ROWS = [
  {
    id: 1,
    parentGroup: 'Random',
    subGroupDescription: 'Isolated Single-Instance Tickets',
    ticketCount: 69,
    totalEffortHours: 1580.6,
    rootCause: 'Non-repeating ad-hoc issues.',
    permanentSolution: 'Handle via standard support operations.',
  },
  {
    id: 2,
    parentGroup: 'Group 8',
    subGroupDescription: 'Payment Transfer Issues',
    ticketCount: 2,
    totalEffortHours: 226.4,
    rootCause: 'Payments not transferred due to inter-account..',
    permanentSolution: 'Implement validation checks for inter-account..',
  },
  {
    id: 3,
    parentGroup: 'Group 3',
    subGroupDescription: 'IDOC Posting Success',
    ticketCount: 4,
    totalEffortHours: 89.2,
    rootCause: 'IDOC posting failures due to missing partner..',
    permanentSolution: 'Update partner master data validation rules.',
  },
  {
    id: 4,
    parentGroup: 'Group 1',
    subGroupDescription: 'IDOC Archiving Requests',
    ticketCount: 3,
    totalEffortHours: 45.8,
    rootCause: 'Archiving job configuration mismatch.',
    permanentSolution: 'Standardize archiving job parameters.',
  },
  {
    id: 5,
    parentGroup: 'Group 2',
    subGroupDescription: 'Business Communication Issues',
    ticketCount: 5,
    totalEffortHours: 62.3,
    rootCause: 'Email notification failures in workflow.',
    permanentSolution: 'Configure SMTP relay and retry logic.',
  },
  {
    id: 6,
    parentGroup: 'Group 4',
    subGroupDescription: 'Real Estate Posting Errors',
    ticketCount: 2,
    totalEffortHours: 31.5,
    rootCause: 'Incorrect cost center assignment.',
    permanentSolution: 'Validate cost center mapping in RE module.',
  },
  {
    id: 7,
    parentGroup: 'Group 5',
    subGroupDescription: 'E-Document Exclusion',
    ticketCount: 1,
    totalEffortHours: 12.1,
    rootCause: 'Missing e-document configuration for vendor.',
    permanentSolution: 'Update vendor master e-document flags.',
  },
];

export const QUERY_SCOPES = [
  'All Groups & Sub-Groups',
  'Random',
  'Group 1',
  'Group 2',
  'Group 3',
  'Group 4',
  'Group 5',
  'Group 8',
];

export const QUICK_PROMPTS = [
  'Were there any user training issues identified across the groups?',
  'What are the top 3 root causes by effort hours?',
  'Which sub-groups have recurring payment issues?',
  'Summarize permanent solutions recommended for Group 8.',
  'Are there any patterns in isolated single-instance tickets?',
];

export const CROSS_GROUP_SAMPLE_RESPONSE =
  'Based on cross-group analysis of 97 shortlisted tickets, user training issues were identified in 3 sub-groups (Group 2, Group 3, and Group 8). The most common training gap relates to inter-account payment transfer procedures and IDOC partner master maintenance. Recommended action: schedule targeted training sessions for finance and logistics teams covering payment workflows and IDOC configuration.';

export const TICKET_RECORDS = [
  {
    id: 'A4203322L',
    macroArea: 'USA',
    parentGroupId: 'Group 1',
    subGroup: 'IDOC Archiving Requests',
    cumulative: 0.18,
    textAnswer: 'Archiving job reconfigured and executed successfully.',
    textRequest: 'Request to archive IDOC records older than 90 days.',
  },
  {
    id: 'A4196823L',
    macroArea: 'USA',
    parentGroupId: 'Random',
    subGroup: 'Random / Isolated',
    cumulative: 44.01,
    textAnswer: 'One-off issue resolved via manual correction.',
    textRequest: 'Invoice posting failed with custom error message.',
  },
  {
    id: 'A4195102L',
    macroArea: 'USA',
    parentGroupId: 'Group 2',
    subGroup: 'Business Communication Issues',
    cumulative: 12.5,
    textAnswer: 'SMTP relay updated; notifications restored.',
    textRequest: 'Workflow emails not being sent to approvers.',
  },
  {
    id: 'A4193847L',
    macroArea: 'USA',
    parentGroupId: 'Group 3',
    subGroup: 'IDOC Posting Success',
    cumulative: 22.3,
    textAnswer: 'Partner master updated; IDOC reprocessed.',
    textRequest: 'IDOC failed due to missing partner number.',
  },
  {
    id: 'A4192105L',
    macroArea: 'USA',
    parentGroupId: 'Group 8',
    subGroup: 'Payment Transfer Issues',
    cumulative: 113.2,
    textAnswer: 'Inter-account validation added; payments transferred.',
    textRequest: 'Payment not transferred between company codes.',
  },
  {
    id: 'A4190876L',
    macroArea: 'USA',
    parentGroupId: 'Group 4',
    subGroup: 'Real Estate Posting Errors',
    cumulative: 15.75,
    textAnswer: 'Cost center mapping corrected in RE module.',
    textRequest: 'RE posting rejected due to invalid cost center.',
  },
  {
    id: 'A4189543L',
    macroArea: 'USA',
    parentGroupId: 'Group 5',
    subGroup: 'E-Document Exclusion',
    cumulative: 12.1,
    textAnswer: 'Vendor e-document flag enabled.',
    textRequest: 'E-document not generated for vendor invoice.',
  },
  {
    id: 'A4188201L',
    macroArea: 'USA',
    parentGroupId: 'Random',
    subGroup: 'Random / Isolated',
    cumulative: 8.42,
    textAnswer: 'Ad-hoc fix applied; no recurrence expected.',
    textRequest: 'Custom report showing incorrect totals.',
  },
  {
    id: 'A4187109L',
    macroArea: 'USA',
    parentGroupId: 'Group 8',
    subGroup: 'Payment Transfer Issues',
    cumulative: 113.2,
    textAnswer: 'Validation rule implemented for inter-account transfers.',
    textRequest: 'Second instance of payment transfer failure.',
  },
  {
    id: 'A4186034L',
    macroArea: 'USA',
    parentGroupId: 'Group 1',
    subGroup: 'IDOC Archiving Requests',
    cumulative: 0.18,
    textAnswer: 'Scheduled archiving job created.',
    textRequest: 'Need to set up recurring IDOC archive job.',
  },
];
